import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token-api'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 1440 })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
